import '.bn{position:relative;}.ssr-plugin'
import '.ih{width:64px;}.ssr-plugin'
import '.ii{height:64px;}.ssr-plugin'
import '.bz{flex-shrink:0;}.ssr-plugin'
import '.v{position:absolute;}.ssr-plugin'
import '.ij{bottom:-4px;}.ssr-plugin'
import '.cv{right:-4px;}.ssr-plugin'
import '.dr{border-radius:50%;}.ssr-plugin'
import '.ik{border:2px solid var(--shades-white);}.ssr-plugin'
import '.z{overflow:hidden;}.ssr-plugin'
import '.il{width:32px;}.ssr-plugin'
import '.im{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bn ih ii bz"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="v ij cv dr ik z il im"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
